import React from "react";
import { FooterContainer, FooterWrap, FooterItem } from "./Footer";

const Footer = () => {
    return (
        <FooterContainer>
            <FooterWrap>
                <FooterItem>ooo.metr@mail.ru</FooterItem>
                <FooterItem>+7(988) 240-52-88</FooterItem>
                <FooterItem>+7(906) 435-23-30</FooterItem>
                <FooterItem>Краснодар и Краснодарский край, Россия</FooterItem>
                <FooterItem>
                    © 2013-2021 ООО Мэтр. Все права защищены.{" "}
                </FooterItem>
            </FooterWrap>
        </FooterContainer>
    );
};

export default Footer;
